import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M12 5.5L5.25 18.25H18.75L12 5.5Z" />
		<Path d="M11.25 18.25H5.25L11.25 6.91666V18.25Z" fill="currentColor" />
	</SVG>
);
